const e = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
    <path fill="currentColor" fill-rule="evenodd"
        d="M6.875 0H2.5C2.10218 0 1.72064 0.158035 1.43934 0.43934C1.15804 0.720644 1 1.10218 1 1.5V12.5C1 12.8978 1.15804 13.2794 1.43934 13.5607C1.72064 13.842 2.10217 14 2.5 14H11.5C11.8978 14 12.2794 13.842 12.5607 13.5607C12.842 13.2794 13 12.8978 13 12.5V6.125H7.5C7.15482 6.125 6.875 5.84518 6.875 5.5V0ZM12.5821 4.875L8.125 0.417893V4.875H12.5821Z"
        clip-rule="evenodd"></path>
</svg>`;
export {
  e as default
};
